<template>

  <div>
    <button
      type="button"
      class="btn"
      :class="value === 'annually' ? 'btn-outline-primary' : 'btn-outline-secondary'"
      @click="input('annually')">
        <input type="radio" :checked="value === 'annually'"> Anual <span class="badge badge-danger">Economize</span>
      </button>
    <button
      type="button"
      class="btn"
      :class="value === 'monthly' ? 'btn-outline-primary' : 'btn-outline-secondary'"
      @click="input('monthly')">
        <input type="radio" :checked="value === 'monthly'"> Mensal
      </button>
  </div>

</template>

<script>
export default {
  name: 'BillingPlans',
  components: {
  },
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    input (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Billing/BillingPlansTypes.vue